export enum DeliveryType {
  Email = 'EMAIL',
  Portal = 'PORTAL',
  EmailAndPortal = 'EMAIL_AND_PORTAL',
}

export const DeliveryTypeToLabelMap = {
  [DeliveryType.Email]: 'Email only',
  [DeliveryType.Portal]: 'Display in portal only',
  [DeliveryType.EmailAndPortal]: 'Email and display in portal',
};

export * as Api from './api';
